(function () {
  'use strict';

  var BREAKPOINT = 750;

  function init(wrapper) {
    if (!wrapper || wrapper.dataset.ceInited === '1') return;
    wrapper.dataset.ceInited = '1';

    var marquee = wrapper.querySelector('.ce-marquee');
    var track = wrapper.querySelector('.ce-track');
    if (!track || !marquee) return;

    var originalCards = Array.prototype.slice.call(track.children);
    if (originalCards.length === 0) return;

    var desktopMode = wrapper.getAttribute('data-desktop-mode') || 'continuous';
    var mobileMode  = wrapper.getAttribute('data-mobile-mode')  || 'stop-motion';
    var autoplayEnabled = wrapper.getAttribute('data-carousel-autoplay') !== 'false';

    var prevBtn = wrapper.querySelector('.ce-arrow--prev');
    var nextBtn = wrapper.querySelector('.ce-arrow--next');

    var currentMode = null;
    var stopMotionTimer = null;
    var resetTimer = null;
    var visualIndex = 0;
    var resizeTimer = null;

    var isDragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var dragMinOffset = 0;
    var dragMaxOffset = 0;
    var suppressClick = false;
    var isHovering = false;

    function isDesktop() {
      return window.innerWidth >= BREAKPOINT;
    }

    function getMode() {
      return isDesktop() ? desktopMode : mobileMode;
    }

    function getStopDurationMs() {
      var varName = isDesktop() ? '--ce-stop-duration-desktop' : '--ce-stop-duration-mobile';
      var raw = getComputedStyle(wrapper).getPropertyValue(varName).trim();
      var seconds = parseFloat(raw);
      if (isNaN(seconds) || seconds <= 0) return 3000;
      return seconds * 1000;
    }

    function getTransitionMs() {
      var varName = isDesktop() ? '--ce-transition-desktop' : '--ce-transition-mobile';
      var raw = getComputedStyle(wrapper).getPropertyValue(varName).trim();
      var ms = parseFloat(raw);
      if (isNaN(ms) || ms <= 0) return 700;
      return ms;
    }

    function clearClones() {
      var children = Array.prototype.slice.call(track.children);
      for (var i = 0; i < children.length; i++) {
        if (originalCards.indexOf(children[i]) === -1) {
          children[i].parentNode.removeChild(children[i]);
        }
      }
    }

    function clearStopMotionTimers() {
      if (stopMotionTimer) {
        clearTimeout(stopMotionTimer);
        stopMotionTimer = null;
      }
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
      }
    }

    function clearActive() {
      var children = Array.prototype.slice.call(track.children);
      for (var i = 0; i < children.length; i++) {
        children[i].classList.remove('is-active');
      }
    }

    function resetTrack() {
      track.style.transition = 'none';
      track.style.transform = '';
      track.classList.remove('ce-track--continuous', 'ce-track--stop-motion', 'ce-track--no-pill-anim', 'ce-track--carousel', 'ce-track--dragging');
      // force reflow
      void track.offsetWidth;
      track.style.transition = '';
    }

    function moveToVisualIndex(idx) {
      var card = track.children[idx];
      if (!card) return;
      var cardCenter = card.offsetLeft + card.offsetWidth / 2;
      var wrapperCenter = marquee.clientWidth / 2;
      var offset = wrapperCenter - cardCenter;
      track.style.transform = 'translateX(' + offset + 'px)';
      clearActive();
      card.classList.add('is-active');
    }

    function silentResetTo(idx) {
      track.classList.add('ce-track--no-pill-anim');
      track.style.transition = 'none';
      visualIndex = idx;
      moveToVisualIndex(visualIndex);
      void track.offsetWidth;
      track.style.transition = '';
      requestAnimationFrame(function () {
        // Keep the pill-anim guard for one extra frame so the reappearing
        // (reset) card's active-pill state lands without re-animating.
        requestAnimationFrame(function () {
          track.classList.remove('ce-track--no-pill-anim');
        });
      });
    }

    function makeCloneSet(position) {
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < originalCards.length; i++) {
        var clone = originalCards[i].cloneNode(true);
        clone.dataset.clone = position;
        clone.setAttribute('aria-hidden', 'true');
        var cloneLinks = clone.querySelectorAll('a');
        for (var j = 0; j < cloneLinks.length; j++) {
          cloneLinks[j].setAttribute('tabindex', '-1');
        }
        fragment.appendChild(clone);
      }
      return fragment;
    }

    function startStopMotion() {
      var N = originalCards.length;

      // Build seamless track: [pre-clones] [originals] [post-clones]
      track.appendChild(makeCloneSet('post'));
      track.insertBefore(makeCloneSet('pre'), track.firstChild);

      track.classList.add('ce-track--stop-motion');
      visualIndex = N; // start centered on first real card

      // initial placement without animation
      track.style.transition = 'none';
      moveToVisualIndex(visualIndex);
      void track.offsetWidth;
      track.style.transition = '';

      if (N < 2) return;

      function loop() {
        visualIndex++;
        moveToVisualIndex(visualIndex);

        if (visualIndex >= 2 * N) {
          // We've stepped onto a post-clone (visually identical to a real card).
          // Pause normal looping, do a silent reset after the transition completes,
          // then resume looping for the remainder of the hold duration.
          if (stopMotionTimer) {
            clearTimeout(stopMotionTimer);
            stopMotionTimer = null;
          }

          var transitionMs = getTransitionMs();
          var stopMs = getStopDurationMs();
          var holdRemaining = Math.max(stopMs - transitionMs - 50, 100);

          resetTimer = setTimeout(function () {
            resetTimer = null;
            silentResetTo(visualIndex - N);
            stopMotionTimer = setTimeout(loop, holdRemaining);
          }, transitionMs + 50);
        } else {
          stopMotionTimer = setTimeout(loop, getStopDurationMs());
        }
      }
      stopMotionTimer = setTimeout(loop, getStopDurationMs());
    }

    function startContinuous() {
      // duplicate cards once for a seamless -50% loop
      track.appendChild(makeCloneSet('continuous'));
      track.classList.add('ce-track--continuous');
    }

    /* ---------- CAROUSEL MODE (arrows + drag + auto-slide) ---------- */

    function getCurrentTranslateX() {
      var t = getComputedStyle(track).transform;
      if (!t || t === 'none') return 0;
      var m = t.match(/matrix\(([^)]+)\)/);
      if (m) return parseFloat(m[1].split(',')[4]) || 0;
      var m3 = t.match(/matrix3d\(([^)]+)\)/);
      if (m3) return parseFloat(m3[1].split(',')[12]) || 0;
      return 0;
    }

    function offsetForIndex(idx) {
      var card = track.children[idx];
      if (!card) return 0;
      return marquee.clientWidth / 2 - (card.offsetLeft + card.offsetWidth / 2);
    }

    function nearestIndexForOffset(offset) {
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var d = Math.abs(offsetForIndex(i) - offset);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return best;
    }

    function normalizeNow() {
      var N = originalCards.length;
      var target = visualIndex;
      while (target >= 2 * N) target -= N;
      while (target < N) target += N;
      if (target !== visualIndex) silentResetTo(target);
    }

    function stopAutoplay() {
      if (stopMotionTimer) {
        clearTimeout(stopMotionTimer);
        stopMotionTimer = null;
      }
    }

    function queueAutoplay(delayMs) {
      stopAutoplay();
      if (currentMode !== 'carousel' || !autoplayEnabled) return;
      if (isHovering || isDragging) return;
      if (originalCards.length < 2) return;
      stopMotionTimer = setTimeout(function () {
        stopMotionTimer = null;
        stepBy(1);
      }, delayMs);
    }

    function scheduleWrapAndResume() {
      var N = originalCards.length;
      var stopMs = getStopDurationMs();
      if (visualIndex >= 2 * N || visualIndex < N) {
        var transitionMs = getTransitionMs();
        if (resetTimer) clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          resetTimer = null;
          normalizeNow();
          queueAutoplay(Math.max(stopMs - transitionMs - 50, 100));
        }, transitionMs + 50);
      } else {
        queueAutoplay(stopMs);
      }
    }

    function stepBy(dir) {
      if (currentMode !== 'carousel') return;
      stopAutoplay();
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
        normalizeNow();
      }
      visualIndex += dir;
      moveToVisualIndex(visualIndex);
      scheduleWrapAndResume();
    }

    function onPointerDown(e) {
      if (currentMode !== 'carousel') return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest && e.target.closest('.ce-arrow')) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      stopAutoplay();
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
      }
      dragStartOffset = getCurrentTranslateX();
      dragMaxOffset = offsetForIndex(0);
      dragMinOffset = offsetForIndex(track.children.length - 1);
      track.style.transition = 'none';
      track.classList.add('ce-track--dragging');
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      var dx = e.clientX - dragStartX;
      if (!dragMoved) {
        if (Math.abs(dx) < 6) return;
        dragMoved = true;
      }
      var next = dragStartOffset + dx;
      if (next > dragMaxOffset) next = dragMaxOffset;
      if (next < dragMinOffset) next = dragMinOffset;
      track.style.transform = 'translateX(' + next + 'px)';
    }

    function onPointerEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('ce-track--dragging');
      track.style.transition = '';
      void track.offsetWidth;
      if (dragMoved) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 60);
        visualIndex = nearestIndexForOffset(getCurrentTranslateX());
        moveToVisualIndex(visualIndex);
        scheduleWrapAndResume();
      } else {
        queueAutoplay(getStopDurationMs());
      }
    }

    function startCarousel() {
      var N = originalCards.length;

      // Same seamless track as stop-motion: [pre-clones] [originals] [post-clones]
      track.appendChild(makeCloneSet('post'));
      track.insertBefore(makeCloneSet('pre'), track.firstChild);

      track.classList.add('ce-track--stop-motion', 'ce-track--carousel');
      wrapper.classList.add('ce-wrapper--carousel');
      visualIndex = N;

      // initial placement without animation
      track.style.transition = 'none';
      moveToVisualIndex(visualIndex);
      void track.offsetWidth;
      track.style.transition = '';

      queueAutoplay(getStopDurationMs());
    }

    function teardown() {
      clearStopMotionTimers();
      clearActive();
      clearClones();
      resetTrack();
      wrapper.classList.remove('ce-wrapper--carousel');
      isDragging = false;
    }

    function applyMode(force) {
      var mode = getMode();
      if (!force && mode === currentMode) return;
      teardown();
      currentMode = mode;
      if (mode === 'continuous') {
        startContinuous();
      } else if (mode === 'carousel') {
        startCarousel();
      } else {
        startStopMotion();
      }
    }

    function onResize() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newMode = getMode();
        if (newMode !== currentMode) {
          applyMode();
        } else if (currentMode === 'stop-motion' || currentMode === 'carousel') {
          // re-center current card after viewport change
          track.style.transition = 'none';
          moveToVisualIndex(visualIndex);
          void track.offsetWidth;
          track.style.transition = '';
        }
      }, 200);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stepBy(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stepBy(1);
      });
    }

    // Block card link clicks that were actually drags
    wrapper.addEventListener('click', function (e) {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Prevent native image/link drag ghosting in carousel mode
    track.addEventListener('dragstart', function (e) {
      if (currentMode === 'carousel') e.preventDefault();
    });

    // Pause auto-slide while hovering (mouse only)
    marquee.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      isHovering = true;
      if (currentMode === 'carousel') stopAutoplay();
    });

    marquee.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      isHovering = false;
      if (currentMode === 'carousel' && !isDragging && !resetTimer) {
        queueAutoplay(getStopDurationMs());
      }
    });

    marquee.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerEnd);
    window.addEventListener('pointercancel', onPointerEnd);

    wrapper._ceCleanup = function () {
      clearStopMotionTimers();
      if (resizeTimer) {
        clearTimeout(resizeTimer);
        resizeTimer = null;
      }
      window.removeEventListener('resize', onResize);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerEnd);
      window.removeEventListener('pointercancel', onPointerEnd);
    };

    applyMode(true);
    window.addEventListener('resize', onResize, { passive: true });
  }

  function initAll() {
    var wrappers = document.querySelectorAll('.ce-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      init(wrappers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var wrapper = e.target.querySelector ? e.target.querySelector('.ce-wrapper') : null;
    if (wrapper) {
      wrapper.dataset.ceInited = '';
      init(wrapper);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var wrapper = e.target.querySelector ? e.target.querySelector('.ce-wrapper') : null;
    if (wrapper && typeof wrapper._ceCleanup === 'function') {
      wrapper._ceCleanup();
    }
  });
})();